import React, { Component } from "react"
import { Link } from "gatsby"

import FeatureCard from "./FeatureCard"
import TheCard from "./TheCard"

export default class CardOffered extends Component {
  render() {
    return (
      <>
        <section id="CardOffered" className="CardOffered lg:py-64 py-32">
          <div className="tilt-card-move">
            <TheCard />
          </div>
        </section>
        <section
          id="CardOffered-price"
          className="CardOffered-price pt-32 lg:px-0 px-8"
        >
          <div className="container mx-auto">
            <div className="offer-price-tag">
              <h4>
                <span className="bold">Get</span> your{" "}
                <span className="bold">card</span> at just
              </h4>
              <div className="offer-price-tag_inner">
                <p className="actual-price">₹ 1499</p>
                <p className="uppercase text-xl">early bird discount</p>
                <div className="discount">
                  <p>₹ 399</p>
                  <span>*No extra hidden charges or tax</span>
                </div>
              </div>
              <div className="random-feature">
                <FeatureCard />
              </div>
            </div>
            <div className="offer_footer">
              <div>
                <a href="#" class="btn">
                  apply for card
                </a>
                <p className="uppercase">
                  buy 2 cards and get both at just ₹ 499
                </p>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
